'use strict';

angular.module('openDataApp')
  .controller('IbanCtrl', ['$scope', '$http', function ($scope, $http) {
    // Showcase logic
    var lastTry;
    $scope.available = true;
    $scope.submitShowcase = function(nr) {
      if (nr === undefined) {
        $scope.nrStatus = 'Vul je rekeningnummer in';
      } else if (nr !== lastTry) {
        lastTry = nr;
        $http.get('https://api.opendata.nu/api/openibandemo?bban=' + nr).
          then(function(response) {
            $scope.nrStatus = null;
            if (response.data.status === 11) {
              $scope.nrStatus = 'Dit is geen geldig rekeningnummer';
            } else if (response.data.status === 404) {
              $scope.nrStatus = 'IBAN niet gevonden';
            } else if (response.data.status === 90) {
              $scope.hasResult = false;
              $scope.nrStatus = 'Je hebt het maximaal aantal gratis omrekeningen bereikt. Neem een betaald abonnement voor meer omrekeningen.';
              $scope.available = false;
            } else if (response.data.status === 50) {
              $scope.hasResult = false;
              $scope.nrStatus = 'Je hebt het maximaal aantal omrekeningen bereikt binnen uw abonnement. De dienst werkt nog wel maar u wordt verzocht een hoger abonnement te nemen.';
              $scope.available = false;
            } else if (response.data.status === 0) {
              $scope.hasResult = true;
              $scope.resultIBAN = response.data.iban;
              $scope.resultBIC = response.data.bic;
              $scope.derived = response.data.derived;
            }
          });
      }
    };
  }])
  .filter('formatIban', ['$sce', function($sce) {
    return function(iban){
      return $sce.trustAsHtml('<span>' + iban.substring(0,2) + '</span><span>' + iban.substring(2,4) + '</span><span>' + iban.substring(4,8) + '</span><span>' + iban.substring(8) + '</span>');
    };
  }]);
